import React, { useState, useEffect, useRef } from 'react';
import './FootprintStats.css';

const FootprintStats = ({ stats }) => {
  const [animatedStats, setAnimatedStats] = useState(stats.map(() => 0));
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const intervals = stats.map((stat, index) => {
      const targetValue = parseInt((stat.number || '0').replace('+', '')) || 0; // Ensure number is defined
      const increment = Math.ceil(targetValue / 100);
      return setInterval(() => {
        setAnimatedStats((prevStats) => {
          const newStats = [...prevStats];
          if (newStats[index] < targetValue) {
            newStats[index] += increment;
            if (newStats[index] > targetValue) newStats[index] = targetValue;
          }
          return newStats;
        });
      }, 40);
    });

    return () => intervals.forEach((interval) => clearInterval(interval));
  }, [isVisible, stats]);

  return (
    <div className="footprint-stats-container" ref={containerRef}>
      {stats.map((stat, index) => (
        <div key={stat._id} className="footprint-stat-item">
          <span className={`stat-icon fa ${stat.icon}`} aria-hidden="true"></span>
          <span className="stat-value">
            {animatedStats[index] || 0}+
          </span>
          <span className="stat-points">{stat.points}</span>
        </div>
      ))}
    </div>
  );
};

export default FootprintStats;
